module.exports = __webpack_public_path__ + "img/factory.b70b82c9.b70b82c9.jpg";